import {IntegrationMessage} from "platform/integration/message/IntegrationMessage";
import {IntegrationClassId} from "platform/integration/message/IntegrationClassId";

export class IntegrationWillDoLater implements IntegrationMessage {

    public classId: number = IntegrationClassId.WILL_DO_LATER;

}
